window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var TOOLTIP_TEMPLATE =
    '<div class="tooltip" role="tooltip"><div class="arrow"></div>' +
    '<i class="fa fa-close btn-close btn-close-top"></i>' +
    '<div class="tooltip-scroll"><div class="tooltip-inner"></div></div>' +
    '<div class="btn-close btn-close-bottom">Close</div></div>';

  function formatPrice(price, decimals) {
    if (typeof decimals === "undefined") {
      decimals = 2;
    }
    var negative = price < 0 ? "-" : "";
    return (
      negative +
      "$" +
      Math.abs(price)
        .toFixed(decimals)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    );
  }

  function formatDateAsLong(date) {
    var cfg = ns.config;
    var d = moment(date, "YYYYMMDD");
    var mask = cfg.site === "brisbane" ? "dddd, Do MMMM" : "dddd MMMM Do";
    if (d.year() !== cfg.today.year()) {
      mask += cfg.site === "brisbane" ? " YYYY" : ", YYYY";
    }
    return d.format(mask);
  }

  function formatDate(date) {
    var cfg = ns.config;
    var d = moment(date, "YYYYMMDD");
    var mask = cfg.site === "brisbane" ? "Do MMMM" : "MMMM Do";
    if (d.year() !== cfg.today.year()) {
      mask += cfg.site === "brisbane" ? " YYYY" : ", YYYY";
    }
    return d.format(mask);
  }

  function formatTime(time) {
    return moment(time, "HH:mm").format("h:mm A");
  }

  function round10(num) {
    return +(Math.round(num + "e+" + 2) + "e-" + 2);
  }

  function addToolTip(element, content) {
    element
      .tooltip({
        delay: { show: 150, hide: 150 },
        html: true,
        trigger: "click",
        template: TOOLTIP_TEMPLATE,
        title: content,
      })
      .on("show.bs.tooltip", function (e) {
        var $backdrop = $('<div class="tooltip-backdrop"></div>');
        $backdrop.data("target", e.currentTarget);
        $("body").append($backdrop);
        $backdrop.on("click", function () {
          var $target = $($(this).data().target);
          $target.tooltip("hide");
        });
      })
      .on("hidden.bs.tooltip", function () {
        $(".tooltip-backdrop").remove();
      });
    return element;
  }

  function showAlert(message) {
    $(".alert-row").show().find(".alert-message").text(message);
  }

  function hideAlert() {
    $(".alert-row").attr({ style: "display: none!important" });
  }

  ns.utils = {
    TOOLTIP_TEMPLATE: TOOLTIP_TEMPLATE,
    formatPrice: formatPrice,
    formatDate: formatDate,
    formatDateAsLong: formatDateAsLong,
    formatTime: formatTime,
    round10: round10,
    addToolTip: addToolTip,
    showAlert: showAlert,
    hideAlert: hideAlert,
  };
})(window.EM.booking);
